import React from "react";
import {Col, Row} from "react-bootstrap";
import clsx from "clsx";

function Column ({title,value1,value2}){
    return <>
        <Col xs={4} sm={4} md={4} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
                <h4 className="m-0">{title}</h4>
            </div>
        </Col>
        <Col xs={4} sm={4} md={4} lg={3} xl={3} className="d-flex flex-column  mt-2">
            <div className={clsx("custom-card-content-settlement-item-container breakword")}>
                        <span className="text-bold-normal">{value1 ? value1 : `0`}
                        </span>
            </div>
        </Col>
        <Col xs={4} sm={4} md={4} lg={3} xl={3} className="d-flex flex-column  mt-2">
            <div className={clsx("custom-card-content-settlement-item-container breakword")}>
                        <span className="text-bold-normal">{value2 ? value2 : `0`}
                        </span>
            </div>
        </Col>
    </>
}
function ProfitAndLossResult({values}){
    return <Col sm={12} md={12} lg={6}>
        <div className="custom-table-statement-content my-3">
            <div className="custom-table-setoff-styled mb-3">
                <h3 className="py-3 px-3 text-bold-600 general-title">Result</h3>
            </div>
            <Row className="pb-3">
                <Col xs={4} sm={4} md={4} lg={6} xl={6} className="d-flex flex-column"></Col>
                <Col xs={4} sm={4} md={4} lg={3} xl={3} className="d-flex flex-column">
                    <div className={clsx("custom-card-content-settlement-item-container")}>
                        <h4 className="m-0">Buy</h4>
                    </div>
                </Col>
                <Col xs={4} sm={4} md={4} lg={3} xl={3} className="d-flex flex-column">
                    <div className={clsx("custom-card-content-settlement-item-container")}>
                        <h4 className="m-0">Sell</h4>
                    </div>
                </Col>
                <Column title={`No of Shares x 100`} value1={values && values.buy_share_text} value2={values && values.sell_share_text}></Column>
                <Column title={`Price`} value1={values && values.buy_share_price} value2={values && values.sell_share_price}></Column>

                <Column title={`Gross Amount`} value1={values && values.buy_gross_amount} value2={values && values.sell_gross_amount}></Column>

                <Column title={`Brokerage`} value1={values && values.buy_brokerage} value2={values && values.sell_brokerage}></Column>

                <Column title={`Clearing Fee`} value1={values && values.buy_clearing_fee} value2={values && values.sell_clearing_fee}></Column>
                <Column title={`Stamp Duty`} value1={values && values.buy_stamp_duty} value2={values && values.sell_stamp_duty}></Column>

                <Column title={`Total Charges`} value1={values && values.buy_total_charges} value2={values && values.sell_total_charges}></Column>
                <Column title={`Total SST Charges`} value1={values && values.buy_sst_charges} value2={values && values.sell_sst_charges}></Column>

                <Column title={`Net Amount`} value1={values && values.buy_net_amount} value2={values && values.sell_net_amount}></Column>
                <Col col={12} ><div className={clsx("profit-container")}>Profit: {values && values.net_profit}
                </div></Col>
            </Row>
        </div>
    </Col>
}

export default ProfitAndLossResult
